import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propFunc, propOneOf, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import HtmlLink from '../../../../Ui/Common/HtmlLink';
import Hover from '../../../../Ui/System/Hover';
import ProfessionalUnitProfessionalCount from './ProfessionalUnitProfessionalCount';
import ProfessionalUnitProfessionalExperience from './ProfessionalUnitProfessionalExperience';
import ProfessionalUnitProfessionalMiddleTasks from './ProfessionalUnitProfessionalMiddleTasks';
import ProfessionalUnitProfessionalThumbnail from './ProfessionalUnitProfessionalThumbnail';
const ProfessionalUnitSolution = (props) => {
    const { itemClassName, professional, showAlertModal, userMode } = props;
    const { department, firstName, id, lastName, middleTasks } = professional;
    const isView = userMode === 'view';
    return (_jsx(Hover, { children: _jsxs(HtmlLink, Object.assign({ className: clsx('unit_professional', itemClassName), isNoLinkComponent: isView ? undefined : 'button', onClickNoLink: isView ? undefined : showAlertModal, target: '_blank', to: `/consultant/${id}`, type: isView ? undefined : 'button' }, { children: [_jsx(ProfessionalUnitProfessionalExperience, { professional: professional }), _jsx(ProfessionalUnitProfessionalThumbnail, { professional: professional }), _jsxs("div", Object.assign({ className: 'body_box' }, { children: [_jsx("h5", Object.assign({ className: 'name_row' }, { children: `${lastName} ${firstName}` })), _jsx("h6", Object.assign({ className: 'department_row' }, { children: department })), _jsx(ProfessionalUnitProfessionalCount, { professional: professional }), _jsx(ProfessionalUnitProfessionalMiddleTasks, { middleTasks: middleTasks })] }))] })) }));
};
ProfessionalUnitSolution.propTypes = {
    itemClassName: propStr(),
    professional: propShape().isRequired,
    showAlertModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
ProfessionalUnitSolution.defaultProps = {
    itemClassName: '',
};
export default ProfessionalUnitSolution;
